import React, { Component } from 'react';
import classNames from 'classnames';
import ActionsBar from '@/ActionsBar';
import Feature from '@/Feature';
import { observer, inject } from 'mobx-react';

@inject("featuresListStore") @observer 
export default class FeaturesList extends Component {
  constructor(props){
    super(props)
  }
  render() {
    let { features, layout} = this.props.featuresListStore;
    let listClass = classNames('billy-features-list',{
      'billy-features-list_grid': layout === 'GRID'
    })
    return (
      <div className={ listClass }>
        <ActionsBar />
        {features.map((feature, i) =>
          <div className={`billy-features-list__item ${i % 2 ? 'billy-features-list__item_left' : ''}`} key={i}>
            <Feature { ...feature } />
          </div>
        )}
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/FeaturesList/index.js